(function () {
  'use strict';

  var timers = Array.prototype.slice.call(document.querySelectorAll('[data-fg-countdown]'));
  if (!timers.length) return;

  var interval = null;

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function setUnit(timer, unit, value) {
    var el = timer.querySelector('[data-fg-unit="' + unit + '"]');
    var text = pad(value);
    if (el && el.textContent !== text) el.textContent = text;
  }

  // A timer that runs out stays on the page at 00; Liquid hides it on the next page load.
  function tick() {
    var now = Date.now();
    var running = false;

    timers.forEach(function (timer) {
      var end = Number(timer.getAttribute('data-fg-countdown')) * 1000;
      var left = Math.max(0, Math.floor((end - now) / 1000));
      if (left > 0) running = true;

      setUnit(timer, 'hours', Math.floor(left / 3600));
      setUnit(timer, 'minutes', Math.floor((left % 3600) / 60));
      setUnit(timer, 'seconds', left % 60);
    });

    if (!running && interval) {
      clearInterval(interval);
      interval = null;
    }
    return running;
  }

  if (tick()) interval = setInterval(tick, 1000);
})();
